<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('my_library_reservations')" :isNewButton="false" :is-filter="false"></Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('my_library_reservations')" :isNewButton="false" :is-filter="false"></HeaderMobile>
            </template>
                    <datatable
                         :title="$t('my_library_reservations')"
                        :isLoading.sync="datatable.isLoading"
                        :columns="datatable.columns"
                        :rows="datatable.rows"
                        :total="datatable.total"
                        :queryParams="datatable.queryParams"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-per-page-change="onPerPageChange"
                        v-show="datatable.showTable">
                    </datatable>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
import qs from "qs";
import LibraryReservationService from "@/services/LibraryReservationService";
import CourseAgreementFormServices from "@/services/CourseAgreementFormServices";
export default {
    components: {
        AppLayout, Header, HeaderMobile
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('cancel'),
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "libraryreservation_changestatus",
                                callback: (row) => {
                                    this.deleteModal(() => {
                                        LibraryReservationService.cancelReservation(row.id,{status:'canceled'})
                                            .then(response => {
                                                this.$toast.success(this.$t('api.' + response.data.message));
                                                this.getStudentReservations();
                                            })
                                            .catch(error => {
                                                this.showErrors(error, null)
                                            });
                                    });
                                },
                                show:(row)=>{
                                    return ['approved'].includes(row.status)
                                }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase("library_rooms"),
                        field: 'library_room_name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("library_chairs"),
                        field: 'library_chair_name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("date"),
                        field: "date",
                        sortable: false,
                        hidden: false,
                        formatFn:(row)=>{
                            return  row?this.toLocaleDate(row):null
                        }
                    },
                    {
                        label: this.toUpperCase("start_time"),
                        field: "start_time",
                        sortable: true,
                        hidden: false,

                    },
                    {
                        label: this.toUpperCase("end_time"),
                        field: "end_time",
                        sortable: true,
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("status"),
                        field: this.getLocaleField('status_name'),
                        formatFn: (value, row) => {
                            let variant = '';
                            if (row.status === 'canceled' || row.status==='not_participated') variant = 'badge-danger';
                            else {
                                variant = 'badge-success';
                            }
                            return '<span class="badge ' + variant + '">' + this.getLocaleText(row,'status_name') + '</span>';
                        }
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {
                        section_status:null
                    },
                    sort: "date",
                    page: 1,
                    limit: 20,
                },
            },
        }
    },
    mounted() {
        this.getStudentReservations()
    },
    computed:{
        user(){
            return this.$store.getters['auth/getUser']
        },
    },

    methods: {
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        closeModal(){
            this.formProcess=null
        },
        async getStudentReservations() {
            try {
                if (!this.user?.active_student_program?.id)return
                this.datatable.showTable=true
                this.datatable.isLoading=true
                const config={
                    params:{
                        filter:{
                            student_program_id:this.user?.active_student_program?.id
                        },
                        limit:-1
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})

                }
                const res =await LibraryReservationService.libraryReservation(config)
                this.datatable.rows = res.data.data
                this.datatable.total = res.data.total
            }catch (err){
                this.showErrors(err,null)
            }finally {
                this.datatable.isLoading=false
            }
        }

    }

};
</script>

<style scoped>
/* Card Styles */
.room-card {
    transition: all 0.3s ease;
    border-radius: 12px;
}
.room-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
}
.icon-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.bg-light-primary {
    background-color: rgba(30, 106, 255, 0.1);
}


</style>
